export default __webpack_public_path__ + "static/media/pinataSub.4f96e5c7.png";